export default __webpack_public_path__ + "media/images/logo/ok-648cbe70ce391056cd52e3b2fbe002ec.svg";